<script setup>

import {useLanguageStore} from "@/pinia";
import {onMounted, ref} from "vue";


const languageStore = useLanguageStore();
const items = [{value:'ko', name : 'Kor'},{ value:'kg', name : 'кыр'}, {value : 'ru', name: 'Рус'}, {value : 'en' , name : "Eng"}];
const newLang = ref("");

const set_language = ()=>{
  languageStore.set_language(newLang.value);
}

onMounted(()=>{
  newLang.value = languageStore.language
})

</script>

<template>
  <div class="langSelect">
    <v-select
        v-model="newLang"
        :items="items"
        item-value="value"
        item-title="name"
        variant="plain"
        width="100"
        hide-details
        density="compact"
        center-affix
        @update:modelValue="set_language"
    >
    </v-select>
  </div>
</template>

<style scoped>
.langSelect{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>